import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import Loader from "@/components/widgets/loader.vue";
// SYSTEMONE
import BaseMixer from "../../BaseMixer";
import { CategoryModel } from "@/store/models/categories/categoryDTO";
import MultiSelectComponent from "@/router/views/entry/components/MultiSelect.vue";
import { EntryModule } from "@/store/modules/entry.module";
import { SettingModule } from "@/store/modules/settings.module";
import { TagConstant } from "@/store/tagConstant";
let CategoryUpsertComponent = /** @class */ (() => {
    let CategoryUpsertComponent = class CategoryUpsertComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.category = new CategoryModel();
            this.isloading = false;
            this.availableTags = [];
        }
        get isAdmin() {
            return SettingModule.userRole == this.admin;
        }
        saveCategory() {
            this.validate("categoryObserver").then((response) => {
                if (response) {
                    this.isloading = true;
                    if (!this.category.exportSortOrder) {
                        this.category.exportSortOrder = null;
                        this.$emit("upsertCategory", this.category);
                    }
                    else {
                        this.$emit("upsertCategory", this.category);
                    }
                }
            });
        }
        cancel() {
            this.$bvModal.hide("category");
        }
        hideModal() {
            this.$bvModal.hide("category");
        }
        stopLoading() {
            this.isloading = false;
        }
        showModal(category) {
            this.category = category;
            this.availableTags = [...EntryModule.tags].filter((tag) => tag.id.toString() !== TagConstant.UnTagged() && !category.reportTags.some((reportTag) => reportTag.id === tag.id));
            this.$bvModal.show("category");
        }
        addFocus() {
            if (this.title == "Add New Category") {
                this.setFocusToInput("category");
            }
        }
        created() {
            if (EntryModule.tags.length === 0) {
                EntryModule.GettingDetailsForAddEntry().then(() => {
                    if (this.category) {
                        this.availableTags = [...EntryModule.tags].filter((tag) => tag.id.toString() !== TagConstant.UnTagged() && !this.category.reportTags.some((reportTag) => reportTag.id === tag.id));
                    }
                });
            }
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], CategoryUpsertComponent.prototype, "title", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], CategoryUpsertComponent.prototype, "buttonName", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], CategoryUpsertComponent.prototype, "cancel", null);
    CategoryUpsertComponent = __decorate([
        Component({
            name: "CategoryUpsertComponent",
            components: {
                SectionLoader,
                Loader,
                MultiSelectComponent,
            },
        })
    ], CategoryUpsertComponent);
    return CategoryUpsertComponent;
})();
export default CategoryUpsertComponent;
